<script>
export default {
  props: {
    alertMessage: {
      type: String,
      default: '',
    },
    modalShow: {
      type: Boolean,
      default: false,
    },
    titleHeader: {
      type: String,
      default: '',
    },
  },
  methods: {
    confirmClicked() {
      this.$emit('confirmClicked')
    },
  },
}
</script>

<template>
  <div>
    <b-modal
      id="modalPopover"
      ref="modal"
      v-model="modalShow"
      :title="titleHeader"
      no-close-on-backdrop
      hide-footer
    >
      <p>{{ alertMessage }}</p>

      <hr class="mt-0" />
      <div class="float-right">
        <BaseEButton name="ok" size="sm" @click.prevent="confirmClicked"
          >OK</BaseEButton
        >
      </div>
    </b-modal>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.btnHover:hover {
  color: $color-text-white;
  background-color: #5a6268 !important;
}
</style>
